(function () {
  'use strict';

  var SELECTOR_BTN = '[data-quantity-selector]';
  var SELECTOR_WRAP = '[data-quantity-wrapper]';
  var SELECTOR_INPUT = '[data-quantity-value]';
  var BOUND = 'data-rb-qty-bound';
  var MINUS_SVG =
    '<svg focusable="false" class="icon icon--minus" viewBox="0 0 10 2" role="presentation"><path d="M10 0v2H0V0z" fill="currentColor"></path></svg>';
  var TRASH_SVG =
    '<svg viewBox="0 0 24 24" width="17" class="icon icon--trash" aria-hidden="true"><use href="#icon-cart-remove"/></svg>';

  function parseNum(value, fallback) {
    var n = parseFloat(value);
    return isFinite(n) ? n : fallback;
  }

  function decimalsOf(step) {
    var str = String(step);
    var match = str.match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) return 0;
    return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
  }

  function isTrashBtn(btn) {
    if (!btn) return false;
    if (btn.getAttribute('aria-label') === 'Remove item') return true;
    return !!btn.querySelector('.icon--trash, use[href="#icon-cart-remove"], use[href*="icon-cart-remove"]');
  }

  function syncCartMinusIcon(wrap) {
    if (!wrap || !wrap.classList.contains('t4s-quantity-cart-item')) return;
    var input = wrap.querySelector(SELECTOR_INPUT);
    var btn = wrap.querySelector('[data-decrease-qty], .is--minus');
    if (!input || !btn) return;

    var qty = parseNum(input.value, 1);
    var showTrash = qty <= 1;
    var hasTrash = isTrashBtn(btn);
    var hasMinus = !!btn.querySelector('.icon--minus');

    if (showTrash && !hasTrash) {
      btn.innerHTML = TRASH_SVG;
      btn.setAttribute('aria-label', 'Remove item');
    } else if (!showTrash && !hasMinus) {
      btn.innerHTML = MINUS_SVG;
      btn.setAttribute('aria-label', 'Decrease quantity');
    }
  }

  function cartChangeUrl() {
    if (window.T4Sroutes && T4Sroutes.cart_change_url) {
      return T4Sroutes.cart_change_url + '.js';
    }
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/change.js';
  }

  function onCartPage() {
    return (
      (document.body && document.body.classList.contains('template-cart')) ||
      /\/cart\/?$/.test(window.location.pathname || '')
    );
  }

  function cartSections() {
    // Match The4 Cart: on /cart request the cart page section, not mini_cart.
    // Requesting mini_cart here injects drawer item markup into [data-cart-items]
    // and completely reformats the cart page after remove/qty update.
    if (onCartPage()) {
      return 'cart_data,' + (window.cartT4SectionID || 'main-cart');
    }
    if (window.T4Sconfigs && T4Sconfigs.cartType === 'disable') {
      return 'cart_data';
    }
    return 'cart_data,mini_cart';
  }

  function changeCartLine(wrap, input, quantity) {
    var item = wrap && wrap.closest('[data-cart-item]');
    var remove = item && item.querySelector('[data-cart-remove]');
    var key =
      (input && (input.getAttribute('data-id') || input.getAttribute('data-key'))) ||
      (remove && remove.getAttribute('data-id')) ||
      '';
    var qty = parseNum(quantity, 0);

    if (!key) {
      if (qty <= 0 && remove) {
        if (window.jQuery) window.jQuery(remove).trigger('click');
        else remove.click();
      }
      return;
    }

    var wrapper = (item && item.closest('[data-cart-wrapper]')) || document.querySelector('[data-cart-wrapper]');
    var bar = item && item.querySelector('.t4s-cart-ld__bar');
    var spinner = bar && bar.querySelector('.t4s-cart-spinner');

    if (wrapper) wrapper.classList.add('is--contentUpdate');
    if (item) item.classList.add('is--update');
    if (bar) bar.removeAttribute('hidden');
    if (spinner) spinner.removeAttribute('hidden');

    function cleanup() {
      if (wrapper) wrapper.classList.remove('is--contentUpdate');
      if (item) item.classList.remove('is--update');
      if (bar) bar.setAttribute('hidden', '');
      if (spinner) spinner.setAttribute('hidden', '');
    }

    var onUpdated = function () {
      cleanup();
      document.removeEventListener('cart:updated', onUpdated);
      if (window.jQuery) {
        try {
          window.jQuery(document).off('cart:updated.rbQtyChange');
        } catch (err) {}
      }
      ensureHitTargets();
    };

    document.addEventListener('cart:updated', onUpdated);
    if (window.jQuery) {
      try {
        window.jQuery(document).one('cart:updated.rbQtyChange', onUpdated);
      } catch (err) {}
    }

    fetch(cartChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        sections: cartSections(),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data && data.status) {
          cleanup();
          if (window.jQuery) window.jQuery(document).trigger('cart:updated');
          else document.dispatchEvent(new CustomEvent('cart:updated'));
          return;
        }
        // Cart page: hard refresh so totals/line items always stay in sync.
        if (onCartPage()) {
          window.location.reload();
          return;
        }
        if (window.T4SThemeSP && T4SThemeSP.Cart && typeof T4SThemeSP.Cart.renderContents === 'function' && data.sections) {
          T4SThemeSP.Cart.renderContents(data.sections);
        } else if (window.T4SThemeSP && T4SThemeSP.Cart && typeof T4SThemeSP.Cart.getToFetch === 'function') {
          T4SThemeSP.Cart.getToFetch();
        } else if (qty <= 0 && remove && remove.getAttribute('href')) {
          window.location.href = remove.getAttribute('href');
          return;
        }
        if (window.jQuery) window.jQuery(document).trigger('cart:updated');
        else document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) {
        console.error(err);
        cleanup();
        if (onCartPage()) {
          window.location.reload();
          return;
        }
        if (qty <= 0 && remove && remove.getAttribute('href')) {
          window.location.href = remove.getAttribute('href');
          return;
        }
        if (window.jQuery) window.jQuery(document).trigger('cart:updated');
        else document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  function removeCartLine(wrap, input) {
    changeCartLine(wrap, input, 0);
  }

  function adjustInput(input, direction) {
    if (!input || input.disabled) return;

    var wrap = input.closest(SELECTOR_WRAP);
    var step = input.getAttribute('step') || '1';
    if (step === 'any') step = '1';
    var stepNum = parseNum(step, 1);
    var min = parseNum(input.getAttribute('min'), 0);
    var maxAttr = input.getAttribute('max');
    var max = maxAttr === null || maxAttr === '' ? null : parseNum(maxAttr, null);
    var current = parseNum(input.value, min || 0);
    var next = direction > 0 ? current + stepNum : current - stepNum;

    if (max !== null && direction > 0 && next > max) next = max;
    if (direction < 0 && next < min) next = min;
    if (next < 0) next = 0;

    var fixed = Number(next.toFixed(decimalsOf(step)));
    if (fixed === current) return;

    input.value = String(fixed);
    input.setAttribute('value', String(fixed));
    input.setAttribute('data-current-qty', String(fixed));

    // Cart page: our click capture blocks theme ajax — post qty and reload.
    if (wrap && wrap.classList.contains('t4s-quantity-cart-item') && onCartPage()) {
      syncCartMinusIcon(wrap);
      changeCartLine(wrap, input, fixed);
      return;
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    if (window.jQuery) {
      try {
        window.jQuery(input).trigger('change');
        // Theme cart ajax listens for this custom event, not native change alone.
        window.jQuery(input).trigger('change:ajaxCart');
      } catch (err) {}
    }

    syncCartMinusIcon(wrap);
  }

  function onSelectorClick(event) {
    var btn = event.target.closest(SELECTOR_BTN);
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var wrap = btn.closest(SELECTOR_WRAP);
    if (!wrap) return;

    var input = wrap.querySelector(SELECTOR_INPUT);
    if (!input) return;

    if (btn.hasAttribute('data-increase-qty') || btn.classList.contains('is--plus')) {
      adjustInput(input, 1);
      return;
    }

    /* Cart page + side cart: trash (qty 1) deletes the line item */
    if (wrap.classList.contains('t4s-quantity-cart-item')) {
      var qty = parseNum(input.value, 1);
      if (qty <= 1 || isTrashBtn(btn)) {
        removeCartLine(wrap, input);
        return;
      }
    }

    adjustInput(input, -1);
  }

  function ensureHitTargets() {
    document.querySelectorAll(SELECTOR_BTN).forEach(function (btn) {
      btn.style.pointerEvents = 'auto';
      btn.style.cursor = 'pointer';
      if (!btn.hasAttribute('type')) btn.setAttribute('type', 'button');
    });
    document.querySelectorAll('.t4s-quantity-cart-item').forEach(syncCartMinusIcon);
  }

  function bind() {
    if (!document.documentElement.hasAttribute(BOUND)) {
      document.addEventListener('click', onSelectorClick, true);
      document.addEventListener(
        'change',
        function (event) {
          var input = event.target.closest(SELECTOR_INPUT);
          if (!input) return;
          var wrap = input.closest(SELECTOR_WRAP);
          syncCartMinusIcon(wrap);
          if (wrap && wrap.classList.contains('t4s-quantity-cart-item') && onCartPage()) {
            changeCartLine(wrap, input, parseNum(input.value, 0));
          }
        },
        true
      );
      document.documentElement.setAttribute(BOUND, '1');
    }
    ensureHitTargets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('cart:updated', ensureHitTargets);
  if (window.jQuery) {
    try {
      window.jQuery(document).on('cart:updated', ensureHitTargets);
    } catch (err) {}
  }
})();
